import zplWorker from '../extensions/zpl/ZplExtension';

export class ZPL {
  static getZPL64FromImage(image: HTMLImageElement | HTMLCanvasElement, options: any = { black: 20 }) {
    return zplWorker().imageToZ64(image, options);
  }
}
